<template>
  <div class="wrapper">
    <cart-head headTitle="确认订单"></cart-head>
    <div class="bgc">
      <div class="shop-container bgw">
        <div class="order-box">
          <div class="box-title">
            <h3>收货地址</h3>
          </div>
          <div class="box-info adress">
            <div class="item" v-for="(item,index) in addressList" :key="index" :class="{'active':curAddressIndex==index}" @click="selectCurAddress(item,index)">
              <div class="name">{{item.name}}</div>
              <div class="tel">{{item.mobile}}</div>
              <div class="address">{{item.area_name}} {{item.address}}</div>
              <div>
                <span class="change" @click="modifyAddress(item)">修改</span>
                <span class="default" @click="setDefault(item)" v-show="item.is_def!=1">设为默认</span>
              </div>
              <div class="default-icon" v-show="item.is_def==1">
                <i class="icon iconfont icondefault"></i>
              </div>
            </div>
            <div class="add-adress item" @click="addAddressFunc">
              <i class="icon iconfont iconadd"></i>
              添加收货地址
            </div>
          </div>
        </div>
        <div class="order-box">
          <div class="box-title">
            <h3>商品清单</h3>
          </div>
          <div class="box-info">
            <div class="cart-list-wrap">
              <div class="item-row item-head">
                <div class="cart-img">&nbsp;</div>
                <div class="cart-name">商品信息</div>
                <div class="cart-info"></div>
                <div class="cart-price">单价</div>
                <div class="cart-num">数量</div>
                <div class="cart-total">小计</div>
              </div>

              <div class="item-row" v-for="(item) in cartList" :key="item.id" v-if="item.is_select == true">
                <div class="cart-img">
                  <img :src="item.products.image_path" alt>
                </div>
                <div class="cart-name">{{item.products.name}}</div>
                <div class="cart-info">
                  <template v-if="item.products.spes_desc">
                    <div v-for="(spe,i) in item.products.spes_desc.split(',')" :key="i" style="margin-bottom:10px;">{{spe}}</div>
                  </template>
                </div>
                <div class="cart-price">{{item.products.price}}元</div>
                <div class="cart-num">{{item.nums}}</div>
                <div class="cart-total">{{item.products.amount}}元</div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="order-box">
          <div class="box-title">
            <h3>配送方式</h3>
          </div>
          <div class="box-info ct">包邮</div>
        </div>-->
        <div class="order-box">
          <div class="box-title">
            <h3>发票</h3>
          </div>
          <div class="box-info invoice ct">
            <template v-if="invoice.type==1">
              <span>不开发票</span>
            </template>
            <template v-else-if="invoice.type==2">
              <span>电子发票</span>
              <span>{{invoice.name}}</span>
              <span>商品明细</span>
            </template>
            <template v-else>
              <span>电子发票</span>
              <span>{{invoice.name}}</span>
              <span>商品明细</span>
            </template>

            <span class="modify" @click="dialogInvoiceVisible=true">修改></span>
          </div>
        </div>
        <div class="order-box foot">
          <div class="l">
            <div class="box-title">
              <h3>优惠券</h3>
            </div>
            <div class="box-info">
              <div>
                <div class="conpon-tabs">
                  <span :class="useCouponType==0?'active':''" @click="useCouponType=0">商品优惠券</span>
                  <span :class="useCouponType==1?'active':''" @click="useCouponType=1">优惠码兑换</span>
                </div>
                <div class="tab-content" v-show="useCouponType==0">
                  <div>
                    <template v-if="userCoupons.length==0">
                      <span>暂无可使用的优惠券</span>
                    </template>
                    <template v-else-if="userCoupons.length>0">
                      <div class="coupon-list">
                        <div class="coupon-wrap" v-for="(item,index) in userCoupons" :key="index" @click="selectCoupon(item,index)" :class="{disabled:item.disabled,checked:item.checked,}">
                          <div class="content">
                            <div class="price">
                              <span class="num">{{item.name}}</span>
                            </div>
                            <div class="desc">{{item.expression1}}&nbsp;&nbsp;{{item.expression2}}</div>
                            <div class="time">{{item.stime}}&nbsp;--&nbsp;{{item.etime}}</div>
                          </div>
                          <div class="status">
                            <template v-if="item.is_used==2">
                              <i class="icon iconfont iconused"></i>
                            </template>
                            <template v-else-if="item.is_expire==2">
                              <i class="icon iconfont iconnouse"></i>
                            </template>
                          </div>
                          <i class="icon iconfont iconmiaojiesellerselected" v-if="item.checked"></i>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="tab-content" v-show="useCouponType==1">
                  <div class="exchange">
                    <span>输入优惠券号码</span>
                    <input type="text" v-model="inputCouponCode">
                    <a href="javascript:;" @click="receiveCoupon">使用</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="r">
            <div class="total-box">
              <div class="item">
                <span class="title">商品件数：</span>
                <span class="num">{{productNums}}件</span>
              </div>
              <div class="item">
                <span class="title">商品总价：</span>
                <span class="num">{{cartData.goods_amount}}</span>
              </div>
              <div class="item" v-if="cartData.goods_pmt_old > 0">
                <span class="title">商品优惠：</span>
                <span class="num">-{{cartData.goods_pmt}}</span>
              </div>
              <div class="item" v-if="cartData.order_pmt_old > 0">
                <span class="title">订单优惠：</span>
                <span class="num">-{{cartData.order_pmt}}</span>
              </div>
              <!-- <div class="item">
                <span class="title">优惠券抵扣：</span>
                <span class="num">-0</span>
              </div>-->
              <div class="item">
                <span class="title">运费：</span>
                <span class="num">{{cartData.cost_freight}}</span>
              </div>
              <div class="item total">
                <span class="title">应付总额：</span>
                <span class="num">
                  <i class="total-num">{{cartData.amount}}</i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="foot-bar">
          <div class="btn" @click="toPay">去结算</div>
        </div>
      </div>
    </div>

    <el-dialog title="发票信息" :visible.sync="dialogInvoiceVisible" class="invoice">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
        <div class="adress-form">
          <div class="invoice-section">
            <span class="tit">发票抬头：</span>
            <div class="form-section invoice-tabs">
              <div class="invoice-type self" :class="{active:invoiceType==0}" @click="invoiceType=0">个人或事业单位</div>
              <div class="invoice-type" @click="invoiceType=1" :class="{active:invoiceType==1}">企业</div>
            </div>
            <div class="invoice-input-wrap">
              <el-form-item prop="title">
                <el-input v-model="ruleForm.title" placeholder="请填写发票抬头"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="invoice-section" v-show="invoiceType==1">
            <span class="tit">纳税人识别号：</span>
            <div class="invoice-input-wrap">
              <el-form-item prop="identify">
                <el-input v-model="ruleForm.identify" placeholder="请输入纳税人识别号"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="invoice-section">
            <span class="tit">收票邮箱：</span>
            <div class="invoice-input-wrap">
              <el-form-item prop="email">
                <el-input v-model="ruleForm.email" placeholder="请输入收票人邮箱"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="invoice-section">
            <span class="tit">发票内容：</span>
            <div class="invoice-input-wrap">
              <span>购买商品详细</span>
            </div>
          </div>
        </div>
        <div class="form-foot">
          <div class="foot-btn save" @click="submitForm('ruleForm')">保存</div>
          <div class="foot-btn cancel" @click="notNeedInvoice">不开发票</div>
        </div>
      </el-form>
    </el-dialog>
    <SelectAddress :dialogAdressVisible="dialogAddressShow" @hideDialog="hideDialog" :data="modifyData" :type="addressDialogType"></SelectAddress>
  </div>
</template>

<script>
import CartHead from "@/components/cart/CartHead.vue";
import SelectAddress from "@/components/address/index";
import { mapActions, mapState } from "vuex";
import { formatMoney } from "@/utils";
export default {
  name: "Order",
  components: { CartHead, SelectAddress },
  props: {},
  data() {
    return {
      cartData: {}, // 购物车商品详情
      params: {
        ids: 0, // 传递过来的购物车id
        area_id: 0, // 收货地址id
        coupon_code: "", // 优惠券码列表(string)多张逗号分隔
        point: 0 // 抵扣积分额
      }, // 监听params参数信息 以重新请求接口
      invoice: {
        type: "1", // 类型 1不开发票 2个人发票 3公司发票
        name: "不开发票", // 发票抬头
        code: "" // 发票税号
      },
      ruleForm: {
        title: "",
        email: ""
      },
      //地址管理
      userShip: {}, // 用户当前选择的收货地址
      receiptType: 1, // 订单类型 1是发货订单 2是门店自提订单
      curAddressIndex: -1,
      modifyData: null,
      dialogAddressShow: false,
      dialogInvoiceVisible: false,
      invoiceType: 0, //发票类型 0个人 1企业
      addressDialogType: 0, // 新增0 修改1
      cartList: [], //商品列表,
      promotions: [], // 促销信息
      userCoupons: [], // 用户的可用优惠券列表
      usedCoupons: {}, // 已经选择使用的优惠券
      inputCouponCode: "", // 输入的优惠券码
      useCouponType: 0 //优惠券tab切换
    };
  },
  watch: {
    params: {
      handler() {
        this.getCartList();
      },
      deep: true
    }
  },
  computed: {

    addressList() {
      return this.$store.state.addressList;
    },
    rules() {
      let formRules = {
        title: [{ required: true, message: "请填写发票抬头", trigger: "blur" }],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ]
      };
      if (this.invoiceType) {
        formRules["identify"] = [
          { required: true, message: "请填写纳税人识别号", trigger: "blur" }
        ];
      }
      return formRules;
    },
    //商品总数量
  // 计算购物车商品数量
    productNums () {
	let nums = 0
	for (let i in this.cartData.list) {
				if(this.cartData.list[i].is_select){
					nums += this.cartData.list[i].nums;
				}
	}
	return nums
    }
  },
  methods: {
    ...mapActions(["getUserShipListAction"]),
    //选择收货地址
    selectCurAddress(item, index) {
      this.curAddressIndex = index;
      this.params.area_id = item.area_id;
      this.userShip = item;
    },
    //不开发票
    notNeedInvoice() {
      this.invoice = {
        type: "1",
        name: "不开发票",
        code: ""
      };
      this.dialogInvoiceVisible = false;
    },
    hideDialog() {
      this.dialogAddressShow = false;
    },
    addAddressFunc() {
      this.dialogAddressShow = true;
      this.modifyData = {};
    },
    modifyAddress(item) {
      this.modifyData = item;
      this.dialogAddressShow = true;
    },
    setDefault(item) {
      this.$api.setDefShip({ id: item.id }).then(res => {
        if (res.status) {
          this.$msg("设置默认地址成功");
          this.getUserShipListAction(); //添加成功获取最新列表
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.invoice = {
            type: this.invoiceType ? "3" : "2",
            name: this.ruleForm.title,
            code: this.invoiceType ? this.ruleForm.identify : ""
            // email:this.ruleForm.email     //邮箱暂无
          };
          this.dialogInvoiceVisible = false;
        } else {
          return false;
        }
      });
    },
    toPay() {
      let data = {
      	source:1,
        cart_ids: this.params.ids,
        coupon_code: this.params.coupon_code,
        point: this.params.point,
        receipt_type: this.receiptType
      };

      if (!this.params.area_id) {
        return this.$msg("请添加收货地址", "warning");
      }
      let delivery = {};
      // 判断是快递配送还是门店自提

      // 快递配送
      delivery = {
        uship_id: this.userShip.id,
        area_id: this.params.area_id
      };
      // 门店自提

      // 发票信息
      data["tax_type"] = this.invoice.type;
      data["tax_name"] = this.invoice.name;
      data["tax_code"] = this.invoice.code;

      data = Object.assign(data, delivery);
      this.$api.createOrder(data).then(res => {
        if (res.status) {
          this.$router.replace({
            name: "cashier",
            params: {
              order_id: res.data.order_id
            }
          });
        }
      });
    },
    // 获取购物车商品详情
    getCartList() {
      let data = this.params;
      data["receipt_type"] = this.receiptType; // 区分订单类型  1快递订单 2门店自提订单
      this.$api.cartList(data).then(res => {
        if (res.status) {
          let data = res.data;

          // 所有价格转换
          data.amount = formatMoney(data.amount);
          data.goods_amount = formatMoney(data.goods_amount);
          data.goods_pmt_old = data.goods_pmt;
          data.goods_pmt = formatMoney(data.goods_pmt);
          data.coupon_pmt = formatMoney(data.coupon_pmt);
          data.order_pmt_old = data.order_pmt;
          data.order_pmt = formatMoney(data.order_pmt);
          data.point_money = formatMoney(data.point_money);
          data.cost_freight = formatMoney(data.cost_freight);

          //购物车详情
          this.cartData = data;
          //商品列表
          this.cartList = data.list;
          // 优惠信息
          this.promotions = data.promotion_list;
          // 使用的优惠券信息
          this.usedCoupons = data.coupon;

          // 判断是否开启积分抵扣并且没有勾选积分使用
          // if (this.isOpenPoint === 1 && !this.isUsePoint) {
          //   let money = {
          //     order_money: data.amount
          //   };
          //   this.$api.usablePoint(money, res => {
          //     if (res.status) {
          //       this.userPointNums = res.data; // 用户总积分
          //       this.canUsePoint = res.available_point; // 可以使用的积分
          //       this.pointMoney = res.point_rmb; // 积分抵扣的总金额
          //     }
          //   });
          // }
        } else if (res.msg === "优惠券不符合使用规则") {
          this.$msg(res.msg, "error");
          this.userCoupons.forEach(item => {
            item["checked"] = false;
            item["disabled"] = false;
          });
          this.params.coupon_code = "";
        } else if (res.data === 15009) {
          this.$msg(res.msg, "error");
          this.params.coupon_code = "";
          this.inputCouponCode = "";
        }
      });
    },
    // 获取用户的默认收货地址
    userDefaultShip() {
      this.$api.userDefaultShip({}).then(res => {
        if (res.status && Object.keys(res.data).length) {
          this.userShip = res.data;
          this.params.area_id = res.data.area_id;
        }
      });
    },

    // 获取收货地址列表
    userShipList() {
      this.getUserShipListAction();
    },

    // 获取用户的可用优惠券信息
    getUserCounpons() {
      let data = {
        display: "no_used"
      };
      this.$api.userCoupon(data).then(res => {
        if (res.status) {
          let _list = res.data.list;
          let nowTime = Math.round(new Date().getTime() / 1000).toString();
          // _list.forEach(item => {
          //   this.$set(item, "checked", false);
          //   // 判断优惠券是否有效(开始时间)
          //   this.$set(
          //     item,
          //     "disabled",
          //     item.start_time > nowTime ? true : false
          //   );
          //   this.$set(item, "cla", item.disabled ? "cci-l bg-c" : "cci-l"); // 绑定相应的class样式
          // });
          _list.forEach(item => {
            item["checked"] = false;
            item["disabled"] = item.start_time > nowTime ? true : false;
          });
          this.userCoupons = _list;
        }
      });
    },
    //选择优惠券
    selectCoupon(item, index) {
      if (item["disabled"]) {
        return alert("不可与已勾选券叠加使用");
      }
      if (item["checked"]) {
        item["checked"] = false;
        this.userCoupons.forEach(item => {
          item["disabled"] = false;
        });
        this.params.coupon_code = "";
      } else {
        item["checked"] = true;
        this.userCoupons.forEach((item, i) => {
          if (i != index) {
            this.userCoupons[i]["disabled"] = true;
          }
        });
        this.params.coupon_code = item.coupon_code;
      }
    },
    //兑换优惠券
    receiveCoupon() {
      if (!this.inputCouponCode) {
        this.$msg("请输入优惠券码", "warning");
      } else {
        this.params.coupon_code = this.inputCouponCode;
      }
    }
  },
  created() {
    let cartIds = this.$route.query.cart_ids;
    this.params.ids = JSON.parse(cartIds);
    this.userDefaultShip();
    this.userShipList();

    this.getUserCounpons();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';

.shop-container {
  padding: 0px 30px;
  box-sizing: border-box;
  margin: 20px auto;
}
.foot-bar {
  padding: 20px;
  text-align: right;
  margin: 0 -30px;
  border-top: 2px solid $border;
  .btn {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: $theme-color;
    width: 160px;
    text-align: center;
    cursor: pointer;
  }
}
.ct {
  color: $theme-color;
}
.order-box {
  &.foot {
    border: none;
    position: relative;
    min-height: 240px;
    .l {
      position: absolute;
      left: 0;
      right: 260px;
      top: 10px;
    }
    .r {
      position: absolute;
      right: 0px;
      bottom: 10px;
      .total-box {
        margin-bottom: 20px;
        .item {
          position: relative;
          padding-left: 100px;
          height: 26px;
          line-height: 26px;
          .title {
            position: absolute;
            left: 0;
            top: 0;
            display: inline-block;
            width: 90px;
            height: 28px;
            line-height: 28px;
            color: #757575;
            text-align: right;
          }
          .num {
            display: block;
            width: auto;
            text-align: right;
            color: $theme-color;
            &.total {
              font-size: 16px;
            }
          }
          &.total {
            margin-top: 10px;
            .total-num {
              font-size: 30px;
            }
          }
        }
      }
    }
  }
  border-bottom: 1px solid $border;
  padding-bottom: 20px;
  padding-top: 10px;
  .box-title {
    display: flex;
    align-items: center;
    h3 {
      height: 40px;
      line-height: 40px;
      font-weight: 550;
      margin-right: 60px;
    }
  }
  .box-info {
    padding: 20px 0px;
    display: flex;
    align-items: center;
    font-size: 14px;
    flex-flow: row wrap;
    &.invoice {
      span {
        padding: 0 8px;
        color: $theme-color;
        &.modify {
          cursor: pointer;
          &:hover {
            color: $theme-color;
          }
        }
      }
    }
    &.adress {
      .item {
        width: 270px;
        height: 180px;
        border: 1px solid $border;
        text-align: left;
        cursor: pointer;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        margin-left: 20px;
        margin-bottom: 20px;
        .default-icon {
          position: absolute;
          top: 0;
          right: 0;
          .icon {
            font-size: 48px;
            color: $theme-color;
          }
        }
        &.active {
          border-color: $theme-color;
          .change,
          .default {
            visibility: visible;
          }
        }
        .name {
          line-height: 30px;
          font-size: 24px;
          margin-bottom: 10px;
        }
        .tel,
        .address {
          line-height: 22px;
          color: #757575;
          margin-bottom: 5px;
        }
        .change {
          position: absolute;
          right: 14px;
          bottom: 20px;
          cursor: pointer;
          color: $theme-color;
          visibility: hidden;
        }
        .default {
          position: absolute;
          right: 70px;
          bottom: 20px;
          cursor: pointer;
          color: $theme-color;
          visibility: hidden;
        }
        &.add-adress {
          text-align: center;
          color: #999;
          transition: all 0.4s ease;
          &:hover {
            border-color: #333;
            color: #333;
            .icon {
              color: #333;
            }
          }
          .icon {
            display: block;
            width: 30px;
            height: 30px;
            margin: 43px auto 8px;
            font-size: 30px;
            line-height: 30px;
            border-radius: 17px;
            transition: all 0.4s ease;
            color: #e0e0e0;
          }
        }
      }
    }
    .pay-type {
      width: 130px;
      @include line-height(36px);
      text-align: center;
      border: 1px solid $border;
      margin-right: 30px;
      transition: all 0.2s;
      cursor: pointer;
      padding: 1px;
      box-sizing: border-box;
      &.active,
      &:hover {
        background: $theme-color;
        color: #fff;
        border: none;
      }
    }
  }
}
.cart-list-wrap {
  width: 100%;
  flex: 1;
  border: 1px solid $border;
}
.item-row {
  display: flex;
  align-items: center;
  border-top: 1px solid $border;
  &.item-head {
    border: none;
    height: 40px;
    .cart-total {
      color: #333;
    }
  }
  .cart-img {
    width: 80px;
    height: 80px;
    padding-right: 20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .cart-name {
    flex: 1;
    margin-right: 20px;
    p {
      line-height: 1.4;
    }
    .tag {
      padding: 1px 10px;
      color: #fff;
      background: $theme-color;
      font-size: 12px;
      margin-right: 10px;
    }
  }
  .cart-info {
    width: 180px;
    color: #757575;
    font-size: 12px;
  }
  .cart-price {
    width: 100px;
    padding-right: 30px;
    text-align: right;
  }
  .cart-num {
    width: 150px;
    text-align: center;
  }
  .cart-total {
    width: 100px;
    padding-right: 30px;
    text-align: right;
    color: $theme-color;
  }
}
.conpon-tabs {
  height: 40px;
  padding-top: 10px;
  span {
    font-size: 14px;
    padding: 6px 0;
    margin-right: 30px;
    cursor: pointer;
    &.active {
      color: $theme-color;
      border-bottom: 2px solid $theme-color;
    }
  }
}
.coupon-wrap {
  width: 220px;
  margin: 0 20px 20px 0;
  transition: all 0.2s;
  cursor: pointer;
  position: relative;
  &.checked {
    background: #fff;
    color: $theme-color;
    outline: 2px solid red;
    .content {
      background: none;
    }
    .icon {
      position: absolute;
      bottom: -3px;
      right: -3px;
      font-size: 24px;
      color: red;
    }
  }
  &.disabled {
    background: #d1d1d1;
    cursor: no-drop;
    .content {
      background: none;
    }
  }
}
.tab-content {
  .exchange {
    span {
      font-size: 12px;
    }
    input {
      border: 1px solid $border;
      width: 150px;
      height: 20px;
      line-height: 20px;
      margin: 0 10px;
    }
    a {
      display: inline-block;
      height: 22px;
      line-height: 22px;
      padding: 0 15px;
      background: $theme-color;
      color: #fff;
    }
  }
}
</style>